
export class Historical{
    tm: number;
    seq: number;
    date: string;
    time: string;
    evnr: number;
    name: string;
    description: string;
    origin: string;
    alid: string;
    comm_gen: string;
    misc10: string;
    misc6: string;
    misc7: string;
    misc8: string;
    

    constructor(){
    }

    setHistorical(tm: number, seq: number, date: string, time: string, envr: number, name: string, description: string, origin: string,
        alid?: string, comm_gen?: string, misc10?: string, misc6?: string, misc7?: string, misc8?: string){
        this.tm = tm;
        this.seq = seq;
        this.date = date;
        this.time = time;
        this.evnr = envr;
        this.name = name;
        this.description = description;
        this.alid = alid;
        this.comm_gen = comm_gen;
        this.misc10 = misc10;
        this.misc6 = misc6;
        this.misc7 = misc7;
        this.misc8 = misc8;
        this.origin = origin;

    }
}